import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getFirstAvailableImageForSize',
})
export class GetFirstAvailableImageForSizePipe implements PipeTransform {
  transform(value: any, ...args: unknown[]): unknown {
    if (!value || (!value?.length && !value?.url)) {
      return 'assets/layout/images/no-image.png';
    }

    const preferredSize = args.length ? args[0] : 200;
    const images = value?.url ? [value] : value; // cater for single image object

    for (let i = 0; i < images.length; i++) {
      const sizes = images[i].sizes;
      if (sizes?.length) {
        const availableAtPreferred = sizes.filter(
          (s) => s.height <= preferredSize
        );
        if (availableAtPreferred.length) {
          //Sorts the filtered values from high to low to give the closest image
          availableAtPreferred.sort((a, b) => b.height - a.height);
          return availableAtPreferred[0].url;
        }
      }
    }

    if (images[0] && images[0].sizes && images[0].sizes.length) {
      return images[0].sizes[0].url;
    }

    return 'assets/layout/images/no-image.png';
  }
}
